import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import uk from './uk.json';
import ru from './ru.json';
import ro from './ro.json';
import en from './en.json';

// Язык сайта всегда украинский. Автоопределение по Telegram/браузеру убрано
// намеренно: при русском окружении сайт оставался русским. Другой язык
// пользователь может выбрать только вручную в настройках; выбор хранится
// в отдельном ключе, чтобы старый автосохранённый barter_lang его не перекрывал.
const LANG_KEY = 'barter_lang_manual';
const SUPPORTED = ['uk', 'ru', 'ro', 'en'];

function initialLanguage(): string {
  const saved = localStorage.getItem(LANG_KEY);
  return saved && SUPPORTED.includes(saved) ? saved : 'uk';
}

i18n.use(initReactI18next).init({
  resources: {
    uk: { translation: uk },
    ru: { translation: ru },
    ro: { translation: ro },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'uk',
  interpolation: { escapeValue: false },
});

export function setLanguage(lng: string): void {
  if (!SUPPORTED.includes(lng)) return;
  localStorage.setItem(LANG_KEY, lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
export { LANG_KEY };
